
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../base/Button';
import DemoModal from './DemoModal';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);

  const navigation = [
    { name: 'Ana Sayfa', href: '/' },
    { name: 'Neden Webcoll?', href: '/neden-webcoll' },
    { name: 'Paketler', href: '/paketler' },
    { name: 'Blog', href: '/blog' },
    { name: 'İletişim', href: '/iletisim' },
  ];

  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-100">
        <nav className="px-6 py-4">
          <div className="flex items-center justify-between max-w-7xl mx-auto">
            <Link to="/" className="flex items-center space-x-3">
              {/* Logo Icon */}
              <div className="relative w-10 h-10 bg-gradient-to-br from-blue-600 to-purple-600 rounded-lg flex items-center justify-center">
                <div className="text-white font-bold text-lg">W</div>
                <div className="absolute -top-1 -right-1 w-4 h-4 bg-gradient-to-br from-purple-500 to-blue-500 rounded-full flex items-center justify-center">
                  <div className="text-white font-bold text-xs">C</div>
                </div>
              </div>
              {/* Logo Text */}
              <div>
                <h1 className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  webcoll
                </h1>
              </div>
            </Link>
            
            <div className="hidden md:flex items-center space-x-8">
              <Link to="/" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer font-medium">Ana Sayfa</Link>
              <Link to="/neden-webcoll" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer font-medium">Neden Webcoll?</Link>
              <Link to="/paketler" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer font-medium">Paketler</Link>
              <Link to="/blog" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer font-medium">Blog</Link>
              <Link to="/iletisim" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer font-medium">İletişim</Link>
            </div>
            
            <div className="hidden md:flex items-center space-x-4">
              <Button 
                variant="outline" 
                size="sm" 
                className="border-gray-300 text-gray-700 hover:border-blue-600 hover:text-blue-600"
                onClick={() => setIsDemoModalOpen(true)}
              >
                Canlı Demo
              </Button>
              <Button 
                size="sm" 
                className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700"
                onClick={() => setIsDemoModalOpen(true)}
              >
                Hemen Başla
              </Button>
            </div>
            
            <button 
              className="md:hidden w-6 h-6 flex items-center justify-center cursor-pointer"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl text-gray-700`}></i>
            </button>
          </div>
          
          {isMenuOpen && (
            <div className="md:hidden mt-4 pb-4 border-t border-gray-100">
              <div className="flex flex-col space-y-4 pt-4">
                <Link to="/" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer font-medium">Ana Sayfa</Link>
                <Link to="/neden-webcoll" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer font-medium">Neden Webcoll?</Link>
                <Link to="/paketler" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer font-medium">Paketler</Link>
                <Link to="/blog" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer font-medium">Blog</Link>
                <Link to="/iletisim" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer font-medium">İletişim</Link>
                <div className="flex flex-col space-y-2 pt-4">
                  <Button 
                    variant="outline" 
                    size="sm" 
                    className="border-gray-300 text-gray-700"
                    onClick={() => setIsDemoModalOpen(true)}
                  >
                    Canlı Demo
                  </Button>
                  <Button 
                    size="sm" 
                    className="bg-gradient-to-r from-blue-600 to-purple-600"
                    onClick={() => setIsDemoModalOpen(true)}
                  >
                    Hemen Başla
                  </Button>
                </div>
              </div>
            </div>
          )}
        </nav>
      </header>

      <DemoModal 
        isOpen={isDemoModalOpen} 
        onClose={() => setIsDemoModalOpen(false)} 
      />
    </>
  );
};

export default Header;
